import type { Tracker } from '@/entities/tracker';

export function canEditTracker(tracker: Pick<Tracker, 'accessLevel'>): boolean {
  return tracker.accessLevel !== 'view';
}

/**
 * `canEdit` is the caller's level on the board: rows, comments, and arranging
 * it (column order, widths, grouping). `canManage` comes from the server and
 * covers the tracker itself: its columns, details, visibility, members and
 * deletion, which stay with its owner and organization admins.
 */
export function useTrackerAccess(tracker: Pick<Tracker, 'accessLevel' | 'canManage'>): {
  canEdit: boolean;
  canManage: boolean;
} {
  return { canEdit: canEditTracker(tracker), canManage: tracker.canManage };
}
